import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotkey-page',
  templateUrl: './hotkey-page.component.html',
  styleUrls: ['./hotkey-page.component.scss']
})
export class HotkeyPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
